<template>
    <!-- Meta Tags -->
    <Head>
        <title>Detona la chispa de cada día con el delicioso sabor de Chokis</title>
        <meta
            type="description"
            content="Además de su increíble sabor, Chokis te comparte recetas para crear exquisitos platillos que detonen la chispa en ti y los tuyos. Descubre más y diviértete al máximo."
            head-key="description"
        />
    </Head>

    <a class="visually-hidden-focusable f-accessibility-link" href="#main-content">Ir a contenido principal</a>

    <!-- Start Header Section -->
    <header class="bg-blue fixed w-full top-0 z-10">
        <div class="container h-16 flex justify-between items-center md:h-20">
            <div class="w-full md:w-auto flex justify-between md:justify-start items-center space-x-4 lg:space-x-8">
                <Link href="/" class="block w-24">
                    <img class="w-full" :src="`/images/logo_chokis.png`" alt="Sitio oficial Chokis" />
                </Link>
                <nav
                    class="hidden md:flex justify-start items-center text-sm lg:text-base space-x-2 lg:space-x-4 font-semibold"
                >
                    <Link href="/productos" class="hover:underline">PRODUCTOS</Link>
                    <Link href="/recetas" class="hover:underline">RECETAS</Link>
                    <Link href="/donde-comprar" class="hover:underline">¿DÓNDE COMPRAR?</Link>
                </nav>
                <button
                    @click="menuShow = !menuShow"
                    class="md:hidden bg-lightblue text-grayblue py-3 px-4 rounded-lg text-xl flex justify-center items-center cursor-pointer"
                >
                    <span v-show="!menuShow" class="text-base">
                        <font-awesome-icon icon="fa-regular fa-bars" />
                        Menú
                    </span>
                    <span v-show="menuShow" class="text-base">
                        <font-awesome-icon icon="fa-regular fa-xmark" />
                        Cerrar
                    </span>
                </button>
            </div>
            <div class="hidden md:flex justify-end items-center space-x-4">
                <div class="flex md:hidden lg:flex justify-center items-center space-x-2 py-4">
                    <a
                        href="https://www.facebook.com/ChokisMx/"
                        target="_blank"
                        class="btn-circle-lightblue"
                        aria-label="Facebook Chokis®"
                    >
                        <font-awesome-icon icon="fa-brands fa-facebook-f" />
                    </a>
                    <a
                        href="https://www.youtube.com/@ChokisOficialMX"
                        target="_blank"
                        class="btn-circle-lightblue"
                        aria-label="Youtube Chokis®"
                    >
                        <font-awesome-icon icon="fa-brands fa-youtube" />
                    </a>
                    <a
                        href="https://www.instagram.com/chokis_mx/"
                        target="_blank"
                        class="btn-circle-lightblue"
                        aria-label="Instagram Chokis®"
                    >
                        <font-awesome-icon icon="fa-brands fa-instagram" />
                    </a>
                </div>
                <div class="relative bg-lightblue text-white rounded w-60">
                    <font-awesome-icon icon="fa-regular fa-magnifying-glass" class="absolute top-3 left-2 text-lg" />
                    <label>
                        <input
                            id="lg_search"
                            class="bg-transparent border-none w-full h-10 pl-8 pr-4 placeholder:text-sm placeholder:text-grayblue pb-1"
                            type="text"
                            placeholder="Buscar producto o receta"
                            v-model="searchGeneralInput"
                            @keyup="searchGeneral"
                        />
                    </label>
                    <div
                        class="w-60 max-h-[50vh] bg-lightblue absolute top-10 left-0 overflow-y-scroll py-4 px-2"
                        v-show="showSquareResults"
                    >
                        <div class="" v-if="searchGeneralRecipes.length">
                            <h2 class="text-base my-2">RECETAS</h2>
                            <Link
                                :href="`${$page.props.baseUrl}/recetas/${recipe.slug}`"
                                @click="searchGeneraClose"
                                v-for="(recipe, index) in searchGeneralRecipes"
                                :key="index"
                                class="group w-full h-auto flex justify-start items-center py-1 overflow-hidden hover:bg-blue"
                            >
                                <img
                                    :src="
                                        recipe.thumbnail
                                            ? `${$page.props.baseUrl}/storage/recipes/${recipe.thumbnail}`
                                            : `https://img.youtube.com/vi/${recipe.video_url}/mqdefault.jpg`
                                    "
                                    :alt="recipe.name"
                                    class="w-8 h-8 object-left flex-1 rounded-full"
                                />
                                <div class="w-full pl-2 leading-4 text-xs">{{ recipe.name.slice(0, 50) }}...</div>
                            </Link>
                        </div>
                        <div class="" v-if="searchGeneralProducts.length">
                            <h2 class="text-base my-2">PRODUCTOS</h2>
                            <Link
                                :href="`${$page.props.baseUrl}/productos/${product.slug}`"
                                @click="searchGeneraClose"
                                v-for="(product, index) in searchGeneralProducts"
                                :key="index"
                                class="group w-full h-auto flex justify-start items-center py-1 overflow-hidden hover:bg-blue"
                            >
                                <img
                                    :src="`${$page.props.baseUrl}/storage/products/${product.image}`"
                                    :alt="product.name"
                                    class="w-8 h-8 object-left flex-1 object-contain"
                                />
                                <div class="w-full pl-2 leading-4 text-xs">
                                    {{ product.name.slice(0, 25) }}
                                </div>
                            </Link>
                        </div>
                        <div class="" v-if="!searchGeneralProducts.length && !searchGeneralRecipes.length">
                            <p class="text-base my-2 text-center">No se encontraron resultados</p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="menuShow" class="absolute top-16 left-0 w-full bg-darkblue py-4 px-4 flex flex-col">
                <div class="relative bg-lightblue text-white rounded w-full">
                    <font-awesome-icon icon="fa-regular fa-magnifying-glass" class="absolute top-3 left-2 text-lg" />
                    <label for="sm_search" class="hidden">Buscar producto o receta</label>
                    <input
                        id="sm_search"
                        class="bg-transparent border-none w-full h-10 pl-8 pr-4 placeholder:text-sm placeholder:text-grayblue"
                        type="text"
                        placeholder="¿Qué estás buscando?"
                    />
                </div>
                <nav class="w-full text-lg font-semibold my-4">
                    <Link href="/productos" class="py-2 border-b border-white">PRODUCTOS</Link>
                    <Link href="/recetas" class="py-2 border-b border-white">RECETAS</Link>
                    <Link href="/donde-comprar" class="py-2 border-b border-white">¿DÓNDE COMPRAR?</Link>
                </nav>
                <div class="flex justify-center items-center space-x-2 py-4">
                    <a href="#" target="_blank" class="btn-circle-lightblue">
                        <font-awesome-icon icon="fa-brands fa-facebook-f" />
                    </a>
                    <a href="#" target="_blank" class="btn-circle-lightblue">
                        <font-awesome-icon icon="fa-brands fa-youtube" />
                    </a>
                    <a href="#" target="_blank" class="btn-circle-lightblue">
                        <font-awesome-icon icon="fa-brands fa-instagram" />
                    </a>
                </div>
            </div>
        </div>
    </header>
    <!-- End Header Section -->

    <main :key="$page.url" class="pt-16 md:pt-20">
        <slot />
    </main>

    <!-- Start Footer Section -->
    <footer
        class="bg-darkblue w-full flex flex-col lg:flex-row justify-center items-center font-helvetica text-white py-8 md:py-2 lg:px-12 gap-4"
    >
        <div class="flex-1 flex flex-col lg:flex-row justify-start items-center px-2 lg:px-0">
            <Link href="/" class="block w-24 lg:mr-8 mr-0 mb-4 lg:mb-0">
                <img class="w-full" :src="`/images/logo_chokis.png`" alt="Sitio oficial Chokis" />
            </Link>
            <div class="">
                <p class="text-sm text-center lg:text-left">
                    COPYRIGHT 2023 Comercializadora PepsiCo, Sociedad de Responsabilidad Limitada de Capital Variable
                    por @PepsiCo.Inc.
                </p>
                <div class="flex flex-col lg:flex-row items-center justify-between">
                    <div class="flex flex-col lg:flex-row justify-start items-center gap-4 text-sm my-4 lg:my-0">
                        <Link href="/aviso-de-privacidad" class="text-center hover:underline lg:py-4"
                            >Aviso de Privacidad
                        </Link>
                        <Link href="/declaracion-de-accesibilidad" class="text-center hover:underline lg:py-4">
                            Declaración de accesibilidad</Link
                        >
                    </div>
                </div>
            </div>
        </div>
        <div class="w-[100px] lg:pt-16 flex flex-col lg:justify-end lg:items-center my-2">
            <a href="https://www.w3.org/WAI/WCAG2A-Conformance" title="Explanation of WCAG 2 Level A Conformance">
                <img
                    class="w-[88px] h-[32px] mx-auto md:mx-0"
                    src="https://www.w3.org/WAI/WCAG21/wcag2.1A-v"
                    alt="Level A conformance,
                            W3C WAI Web Content Accessibility Guidelines 2.1"
                />
            </a>
        </div>
        <div class="flex-1 text-sm flex flex-col justify-end gap-4">
            <div class="flex flex-col gap-4 items-center">
                <div>
                    Tel. Atención: <a href="tel:8009019500" class="inline hover:underline lg:py-4">800 901 9500</a>
                </div>
                <div class="mt-4 md:mt-0">
                    Correo:
                    <a href="mailto:consumidores.1800@pepsico.com" class="inline hover:underline lg:py-4"
                        >consumidores.1800@pepsico.com</a
                    >
                </div>
            </div>

            <div class="flex justify-center">
                <a
                    href="https://www.facebook.com/ChokisMx/"
                    target="_blank"
                    class="text-2xl p-4 rounded-lg hover:bg-white hover:bg-opacity-20"
                    aria-label="Facebook Chokis®"
                >
                    <font-awesome-icon icon="fa-brands fa-facebook-f" />
                </a>
                <a
                    href="https://www.youtube.com/@ChokisOficialMX"
                    target="_blank"
                    class="text-2xl p-4 rounded-lg hover:bg-white hover:bg-opacity-20"
                    aria-label="Youtube Chokis®"
                >
                    <font-awesome-icon icon="fa-brands fa-youtube" />
                </a>
                <a
                    href="https://www.instagram.com/chokis_mx/"
                    target="_blank"
                    class="text-2xl p-4 rounded-lg hover:bg-white hover:bg-opacity-20"
                    aria-label="Instagram Chokis®"
                >
                    <font-awesome-icon icon="fa-brands fa-instagram" />
                </a>
            </div>
        </div>
    </footer>
    <!-- End Footer Section -->
</template>

<script>
import axios from "axios";

export default {
    name: "Layout",
    components: {
        axios,
    },
    data() {
        return {
            menuShow: false,
            searchGeneralActive: false,
            showSquareResults: false,
            searchGeneralInput: null,
            searchGeneralRecipes: [],
            searchGeneralProducts: [],
        };
    },
    methods: {
        searchGeneral() {
            if (!this.searchGeneralInput) {
                this.showSquareResults = false;
            } else {
                axios
                    .get(`${this.$page.props.baseUrl}/buscar?searchInput=${this.searchGeneralInput}`)
                    .then((resp) => {
                        this.searchGeneralRecipes = resp.data.recipes;
                        this.searchGeneralProducts = resp.data.products;
                        this.showSquareResults = true;
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        searchGeneraClose() {
            this.showSquareResults = false;
            this.searchGeneralActive = false;
            this.searchGeneralInput = "";
            this.searchGeneralRecipes = [];
            this.searchGeneralProducts = [];
        },
    },
};
</script>

<style>
/* we will explain what these classes do next! */
.v-enter-active,
.v-leave-active {
    transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.swiper-button-prev,
.swiper-button-next {
    width: 50px !important;
    height: 50px !important;
}
</style>
